import { library } from '@fortawesome/fontawesome-svg-core';

import { faArrowLeft, faCheckCircle, faPlay } from '@fortawesome/free-solid-svg-icons';

library.add(faPlay);
library.add(faCheckCircle);
library.add(faArrowLeft);
